import {useEffect, useState} from 'react'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { FiGrid } from 'react-icons/fi'
import { RiAncientPavilionLine, RiContactsLine } from 'react-icons/ri'

import { BASE_URL, SUBCATEGORIES_API, ORGANIZATIONS_API } from '../../../../Utilities/APIs'

import CreateButton from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDashboardBoilerplate/CRUDHeader/CreateButton/CreateButton'
import CRUDTable from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTable'
import CRUDTableHeader from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDTableHeader'
import CRUDth from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableHeader/CRUDth/CRUDth'
import ShortTextCell from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ShortTextCell/ShortTextCell'
import CRUDTableRow from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableRow/CRUDTableRow'
import Modal from '../../../Partials/Elements/Modal/Modal'
import ViewOrganization from './OrganizationCRUDS/ViewOrganization'
import CreateOrganization from './OrganizationCRUDS/CreateOrganization'
import UpdateOrganization from './OrganizationCRUDS/UpdateOrganization'
import CRUDDeleteBoilerPlate from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDDeleteBoilerPlate/CRUDDeleteBoilerPlate'
import ImageCell from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDTable/CRUDTableCells/ImageCell/ImageCell'
import ViewButton from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/ViewButton/ViewButton'
import EditButton from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/EditButton/EditButton'
import CRUDButton from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/CRUDButton'
import Search from '../../../Partials/Elements/Search/Search'
import DeleteButton from '../../../Partials/Layouts/CRUDs/CRUDBoilerPlate/CRUDTableBoilerPlate/CRUDButtons/DeleteButton/DeleteButton'

function Organizations() {

    const [organizations, setOrganizations] = useState(null)
    console.log(organizations)
    const [subcategories, setSubcategories] = useState(null)
    const [showModal, setShowModal] = useState(false)
    const [targetID, setTargetID] = useState(null)
    const [showViewSection, setShowViewSection] = useState(false)
    const [showCreateForm, setShowCreateForm] = useState(false)
    const [showUpdateForm, setShowUpdateForm] = useState(false)
    const [showDeleteSection, setShowDeleteSection] = useState(false)
    const [toggleFetch, setToggleFetch] = useState(false)

    const [searchQuery, setSearchQuery] = useState('')
    const [searchedOrgs, setSearchedOrgs] = useState(null)

    const {employee} = useSelector(state => state.auth)

    useEffect(() => {

        const config = {
            headers: {
                Authorization: `Bearer ${employee.token}`
            }
        }

        async function fetchAndSetOrganizations() {
            const {data} = await axios.get(ORGANIZATIONS_API, config)
            setOrganizations(data)
        }

        fetchAndSetOrganizations()

        async function fetchAndSetSubcategories() {
            const {data} = await axios.get(SUBCATEGORIES_API, config)
            setSubcategories(data)
        }

        fetchAndSetSubcategories()

    }, [employee.token, toggleFetch])

    useEffect(() => {
        if (organizations) {
            if (searchQuery === '') {
                setSearchedOrgs(organizations)
            }
            if (searchQuery !== '') {
                setSearchedOrgs(organizations.filter(o => o.name.includes(searchQuery)))
            }
        }
    }, [searchQuery, organizations])

    function handleClose() {
        setShowModal(false);
        setShowCreateForm(false);
        setShowViewSection(false);
        setShowUpdateForm(false);
        setShowDeleteSection(false);
    }

    function triggerFetch() {
        setToggleFetch(prevState => !prevState)
    }

    const navigate = useNavigate()

    return (
        <>
            <div>
                <div className="body_header">
                    <h1 className="heading">{`Organizations (${organizations?.length} in total)`}</h1>
                    <Search value={searchQuery} setState={setSearchQuery} />
                    <CreateButton
                        screenTopicSingular='Organization'
                        setShowModal={setShowModal}
                        setShowCreateForm={setShowCreateForm}
                    />
                </div>
                <CRUDTable>
                    <CRUDTableHeader>
                        <CRUDth th= 'Organization Name' />
                        <CRUDth th= 'Card Image' />
                        <CRUDth th= 'Subcategory' />
                        <CRUDth th= 'Cost' />
                        <CRUDth th= 'Actions' />
                    </CRUDTableHeader>
                    <tbody>
                        {subcategories && searchedOrgs?.map(item => (
                            <CRUDTableRow key={item._id}>
                                <ShortTextCell text={item.name} />
                                <ImageCell imgSrc={BASE_URL + item.cardImage.slice(6, item.cardImage.length)} alt={item.name} />
                                <ShortTextCell text={subcategories.find(sub => sub._id === item.subcategory).name} />
                                <ShortTextCell text={item.cost} />
                                
                                <td className="action_button_cell">
                                    <ViewButton
                                    setShowModal={setShowModal}
                                    setShowViewSection={setShowViewSection}
                                    targetID={item._id}
                                    setTargetID={setTargetID}
                                    />
                                    <EditButton
                                        setShowModal={setShowModal}
                                        setShowUpdateForm={setShowUpdateForm}
                                        targetID={item._id}
                                        setTargetID={setTargetID}
                                    />
                                    {
                                        employee.level === 'superAdmin' &&
                                        <DeleteButton
                                            setShowModal={setShowModal}
                                            setShowDeleteSection={setShowDeleteSection}
                                            targetID={item._id}
                                            setTargetID={setTargetID}
                                        />
                                    }
                                    <CRUDButton handleClick={() => navigate('/organizationContacts/' + item._id)}>
                                        <RiContactsLine />
                                    </CRUDButton>
                                    <CRUDButton handleClick={() => navigate('/organizationCards/' + item._id)}>
                                        <FiGrid />
                                    </CRUDButton>
                                    <CRUDButton handleClick={() => navigate('/branches/' + item._id)}>
                                        <RiAncientPavilionLine />
                                    </CRUDButton>
                                </td>
                            </CRUDTableRow>
                        ))}
                    </tbody>
                </CRUDTable>
            </div>
            {showModal && 
                <Modal
                    handleClose={handleClose}
                    modalHeading={
                        (showViewSection && `View Organization`) || 
                        (showCreateForm && `Create Organization`) || 
                        (showUpdateForm && `Update Organization`) || 
                        (showDeleteSection && `Delete Organization`)
                    }
                >
                    {
                        showViewSection &&
                            <ViewOrganization
                                targetID={targetID}
                                employee={employee}
                            />
                    }    
                    {
                        showCreateForm &&
                            <CreateOrganization
                                employee={employee}
                                setShowCreateForm={setShowCreateForm}
                                setShowModal={setShowModal}
                                triggerFetch={triggerFetch}
                            />
                    }    
                    {
                        showUpdateForm &&
                            <UpdateOrganization
                                employee={employee}
                                targetID={targetID}
                                setShowUpdateForm={setShowUpdateForm}
                                setShowModal={setShowModal}
                                triggerFetch={triggerFetch}
                            />
                    }
                    {
                        showDeleteSection &&
                            <CRUDDeleteBoilerPlate
                                api={ORGANIZATIONS_API}
                                targetID={targetID}
                                employee={employee}
                                setShowModal={setShowModal}
                                setShowDeleteSection={setShowDeleteSection}
                                hasName
                                triggerFetch={triggerFetch}
                            />
                    }    
                </Modal>
            }
        </>
    )
}

export default Organizations